export default {
    SAVE_SEARCH_PARAMS: 'MANHOUR/QUERY/SAVE_SEARCH_PARAMS',
    SAVE_PAGINATION: 'MANHOUR/QUERY/SAVE_PAGINATION',
    UPDATE_CLEAR_STATE: 'MANHOUR/QUERY/UPDATE_CLEAR_STATE',
    UPDATE_USE_STATE: 'MANHOUR/QUERY/UPDATE_USE_STATE',
}


// WEBPACK FOOTER //
// ./src/components/manHour/query/store/constants.js